import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, Router, withHashLocation} from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {requestBuildInterceptor} from './utils/interceptors/request-build.interceptor';
import {errorHandleInterceptor} from './utils/interceptors/response-error.interceptor';
import {provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage} from 'ngx-webstorage';
import Flow from "@flowjs/flow.js";
import {FlowInjectionToken} from '@flowjs/ngx-flow';
import {provideAnimations} from '@angular/platform-browser/animations';
import {GALLERY_CONFIG, GalleryConfig, GalleryModule} from 'ng-gallery';
import {SentryErrorHandlerService} from './services/sentry-error-handler.service';
import * as Sentry from "@sentry/angular";
import {MissingTranslationHandler, provideTranslateService, TranslateLoader} from '@ngx-translate/core';
import {TranslateLSLoader} from './utils/other/translate-ls-loader';
import {TranslateHandler} from './utils/other/translate-handler';


export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(GalleryModule),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([errorHandleInterceptor, requestBuildInterceptor])),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateLSLoader
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: TranslateHandler
      },
    }),
    provideNgxWebstorage(
      withNgxWebstorageConfig({ prefix: 'support', separator: ':', caseSensitive: true }),
      withLocalStorage(),
      withSessionStorage()
    ),
    {
      provide: FlowInjectionToken,
      useValue: Flow
    },
    {
      provide: GALLERY_CONFIG,
      useValue: {
        imageSize: 'contain'
      } as GalleryConfig
    },
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandlerService,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ]
};
